import React from 'react';
import { Toolbar, AppBar, Typography, Container, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useReactRouter from 'use-react-router';
const AppMenu = (props) => {
  // console.log('hello', props)
  const history = useHistory();
  const { match } = useReactRouter();

  function goHome() {
    history.push(`/alumni-application/${match.params.id}`);
  }
  function viewView() {
    history.push(`/alumni-view/${match.params.id}`);
  }   
  function viewPayment() {
    history.push(`/alumni-payment/${match.params.id}`);
  }


  function downloadForm() {
    history.push(`/alumni-download/${match.params.id}`);
  }

  return (
    <>
      <div style={{ display: "flex", marginBottom: "20px", marginTop: "20px", justifyContent: "center" }}>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#f68b1f" }} onClick={() => goHome()}> Apply</Button>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#f68b1f" }} onClick={() => viewView()}> View</Button>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#f68b1f" }} onClick={() => viewPayment()}> Payment</Button>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#f68b1f" }} onClick={() => downloadForm()}> Download</Button>
        
      </div>

    </>
  );
};

export default AppMenu;